import React, { useEffect, useState } from "react";
import { useProfile } from './ProfileContext';
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  const { selectedProfileId, selectProfile } = useProfile();
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/profile/list-profiles');
        const data = await response.json();
        setProfiles(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []); // Assurez-vous de passer un tableau vide comme deuxième argument pour exécuter useEffect une seule fois


  const handleProfileClick = (profileId) => {
    // Mettez à jour l'id du profil lorsqu'un profil est cliqué
    selectProfile(profileId);
  };

  if (profiles.length === 0) {
    // Redirection vers la création de profil si la liste est vide
    navigate("/create_profile/:id");
  }




  return (
    <section className="profile">
      <h2>Selectionner votre profil</h2>
      <div className="liste_profile">
        {profiles.map(profile => (
          <div className="profil" key={profile._id} onClick={() => handleProfileClick(profile._id)}>
            <a href={`/acceuil`}>
              <div
                className="image_profile"
                style={{ backgroundImage: `url(${profile.url})` }}
              ></div>
            </a>
            <h3 className="nom_profile">{profile.nom}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Profile;
